const useLocal = () => {
	const get = (name) => {
		const item = localStorage.getItem(name);
		return JSON.parse(item);
	};

	const set = (name, item) => {
		localStorage.setItem(name, JSON.stringify(item));
	};

	return {
		get,
		set,
	};
};

export default useLocal;
